/**
 * 会员详情
 */

/** 基本信息 */
// 查询会员信息-旧平台
export const USER_INFO_OLD = '/ccrm2/vipBoard/getUserInfo';
// 绑定平台
export const USER_PLATFORM = '/ccrm2/user/getPlatform';

/** 等级权益 */
// 查询会员等级
export const USER_LEVEL = '/cmvip/level/getLevelByUid';
// 查询会员权益
export const USER_GIFT = '/cmvip/giftBagApi/vipGift';
// 查询会员成长值明细
export const USER_GROWTH_DETAIL = '/cmvip/growthUpApi/getVipGrowthList';

/** 会员积分 */
// 查询会员积分
export const USER_INTEGRAL_INFO = '/cmvip/giftBagApi/vipPoint';
// 查询积分明细
export const USER_INTEGRAL_DETAIL = '/cmvip/integralRuleApi/getScoreDetail';

/** 行为信息 */
// 查询会员行为信息
export const USER_ACTION_LIST = '/ccrm2/user/getOrderInfo';
// 查询会员行为信息-COLMO
export const USER_ACTION_LIST_COLMO = '/ccrm2-core/saleOrderApi/orderList';

/** 操作日志 */
export const USER_OPERATE_LOG = '/cmvip/giftBagApi/operateLog';

/** 会员标签 */
export const USER_TAGS = '/ccrm2/user/getLabel';

/** 地址信息 */
export const USER_ADDRESS_LIST = '/ccrm2-core/userAddr/getUserAddrPageList';

/** 美的品牌 —— 消费信息 */
export const GROWTH_UP_API_GET_OFFLINE_ORDER = '/ccrm2/offlineOrder/getOfflineOrder';
